export const runConfig = {
  "request_domain": {
    "dev": "https://gw-me-kaifa.myxrk.cn",
    "test": "https://gw-me-test.myxrk.cn",
    "pre": "https://gw-me-ysc.myxrk.cn",
    "prod": "https://gw-me.myxrk.com"
  },
  "platform-type": 1,
  "platform-id": 1,
  "CDN_PATH": "/myxrk-v2/front-end/build/prod/webview/xrk",
  "__env__": "env 未启用",
  "env": {
    "dev": {},
    "test": {},
    "pre": {},
    "prod": {}
  },
  "run_request_domain": "https://gw-me.myxrk.com"
}